import { render, staticRenderFns } from "./match.vue?vue&type=template&id=e2b0a34c&scoped=true&"
import script from "./match.vue?vue&type=script&lang=js&"
export * from "./match.vue?vue&type=script&lang=js&"
import style0 from "./match.vue?vue&type=style&index=0&id=e2b0a34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b0a34c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b0a34c')) {
      api.createRecord('e2b0a34c', component.options)
    } else {
      api.reload('e2b0a34c', component.options)
    }
    module.hot.accept("./match.vue?vue&type=template&id=e2b0a34c&scoped=true&", function () {
      api.rerender('e2b0a34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/match.vue"
export default component.exports